import { ReactNode } from "react";
import { atom } from "recoil";

export interface IModal {
  id: string;
  modalchildren: ReactNode;
  visible?: boolean;
  // isSlide?: boolean;
  edge?: "center" | "bottom";
  backdropRemove?: boolean;
}

export const modalState = atom<IModal[]>({
  key: "modalState",
  default: [],
});
